import React, { useEffect, useState, useCallback } from "react";
import Marquee from "react-fast-marquee";
import Styles from "./DamStrip.module.css";
import { getDamData } from "../../../../Services/BuySell/Listing";
import { formatDateType } from "../../../../commons/FormatDate";

const DamStrip = ({ speed = 25, pauseOnHover = true }) => {
  const [damData, setDamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchDamData = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      const data = await getDamData();
      setDamData(data);
    } catch (err) {
      console.error("Error fetching DAM data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDamData();
  }, [fetchDamData]);

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ display: "flex", gap: "10px" }}>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
          <div className={Styles.stripBox}>
            <div className={Styles.skeletonText}></div>
            <div className={Styles.skeletonValue}></div>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className={Styles.stripBox}>
          <div className={Styles.error}>
            <span>⚠️</span> Failed to load DAM data
          </div>
        </div>
      );
    }

    const items = [
      {
        label: "DAM ",
        date: damData?.dam?.current_day?.date,
        val: damData?.dam?.current_day?.val,
      },
      {
        label: "DAM ",
        date: damData?.dam?.prev_day?.date,
        val: damData?.dam?.prev_day?.val,
      },
      {
        label: "RTM ",
        date: damData?.rtm?.current_day?.date,
        val: damData?.rtm?.current_day?.val,
      },
      {
        label: "RTM ",
        date: damData?.rtm?.prev_day?.date,
        val: damData?.rtm?.prev_day?.val,
      },
    ];

    return (
      <div style={{ display: "flex" }}>
        {items.map((item, idx) => (
          <div
            key={idx}
            style={{ margin: "0px 10px" }}
            className={Styles.stripBox}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span
                className={
                  item.label.includes("DAM") ? Styles.damLabel : Styles.rtmLabel
                }
              >
                {item.label}
              </span>
              {item.date && (
                <span
                  style={{
                    color: item.label.includes("DAM") ? "#34656d" : "#d32f2f",
                    fontSize: "12px",
                  }}
                >
                  ({formatDateType(item.date)})
                </span>
              )}{" "}
              -
            </div>
            <div
              style={{
                color: item.label.includes("DAM") ? "#34656d" : "#d32f2f",
              }}
            >
              {item.val != null ? `${Number(item.val).toFixed(3)} ₹/kWh` : "-"}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={Styles.scheduleStrip}>
      <Marquee
        pauseOnHover={pauseOnHover}
        gradient={false}
        speed={speed}
        autoFill={!loading && !error}
        play={!loading}
      >
        {renderContent()}
      </Marquee>
    </div>
  );
};

export default DamStrip;
